import BaseClient from '@/app/model/api/response/baseApiClient'

class VarietyGrowthDeleteApi extends BaseClient {
  public doVarietyGrowthDelete (id: string) {
    const path: string = '/v1/master/variety-growths/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new VarietyGrowthDeleteApi()
